import Styles from './InstagramPreview.module.scss'
import cx from 'classnames'

interface Props {
  activeIndex?: number
  setActiveIndex?: (index: number) => void
  count: number
}

export const CarouselDots = ({ count, activeIndex = 0, setActiveIndex }: Props) => {
  const dotsCount = Math.min(count, 10)

  return (
    <div className={Styles.carouselDots}>
      {Array.from({ length: dotsCount }).map((_, index) => (
        <div
          key={index}
          data-testid={`dot-${index}`}
          className={cx(Styles.carouselDot, { [Styles.active]: index === activeIndex })}
          onClick={() => setActiveIndex?.(index)}
        />
      ))}
    </div>
  )
}
